module.exports = __webpack_public_path__ + "static/interstate-condensed-8c5d568806036f9814c79ac7b9772c90.woff2";